import React, { useState } from 'react';
import {
  Alert,
  Container,
  LinearProgress,
} from '@mui/material';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import RegistrationForm from './components/RegistrationForm/RegistrationForm';
import useBl from './hooks/useBl';
import PatientList from './components/PatientList/PatientList';
import PatientSearchTextBox from './components/PatientSearchTextBox/PatientSearchTextBox';

const SavePatientsForVisit = () => {
  const [showForm, setShowForm] = useState();
  const [searchMode, setSearchMode] = useState('');
  const [selectedPatient, setSelectedPatient] = useState();
  const [showSearchBox, setShowSearchBox] = useState(true);

  const {
    addPatientParams,
    HandleGatherData,
    formData,
    gatheredData,
    searchBase_dataArray,
    initialData,
  } = useBl(showForm, selectedPatient);

  const searchBase_label = FindLangKey(
    'general-public-search-based-on'
  );
  const alertLabel = FindLangKey(
    'general-public-flat-alert-no-data'
  );

  return (
    <React.Fragment>
      {addPatientParams === null ? (
        <LinearProgress />
      ) : addPatientParams === undefined ? (
        <></>
      ) : (
        <Container>
          <br />
          <PatientSearchTextBox
            searchBase_label={searchBase_label}
            searchBase_dataArray={searchBase_dataArray}
            setSearchMode={setSearchMode}
            searchMode={searchMode}
            HandleGatherData={HandleGatherData}
            initialData={initialData}
            setShowForm={setShowForm}
            showSearchBox={showSearchBox}
            setShowSearchBox={setShowSearchBox}
          />

          {showForm ? (
            <>
              {/* <hr style={{ marginBlock: '1em' }} /> */}
              <RegistrationForm
                gatheredData={gatheredData}
                formData={formData}
                addPatientParams={addPatientParams}
                setShowForm={setShowForm}
                showForm={showForm}
                selectedPatient={selectedPatient}
                setShowSearchBox={setShowSearchBox}
              />
            </>
          ) : gatheredData?.FoundPatient === 0 ? (
            <LinearProgress sx={{ mt: '1em' }} />
          ) : gatheredData?.FoundPatient?.length === 0 ||
            !gatheredData?.FoundPatient ? (
            <Alert severity="warning" sx={{ mt: '1em' }}>
              {alertLabel}
            </Alert>
          ) : (
            <PatientList
              patients={gatheredData?.FoundPatient}
              setShowForm={setShowForm}
              setSelectedPatient={setSelectedPatient}
            />
          )}
        </Container>
      )}
    </React.Fragment>
  );
};

export default SavePatientsForVisit;
